import { GraviButton } from '@gravitate-js/excalibrr'
import { Popconfirm, type PopconfirmProps } from 'antd'
import { useState } from 'react'

type PopconfirmButtonProps = {
  onConfirm: () => void
  buttonProps: Omit<React.ComponentProps<typeof GraviButton>, 'onClick'>
  popconfirmProps: Omit<PopconfirmProps, 'onConfirm' | 'open' | 'onOpenChange'> & { disabled?: boolean }
}

export function PopconfirmButton({ onConfirm, buttonProps, popconfirmProps }: PopconfirmButtonProps) {
  const [open, setOpen] = useState(false)
  const { disabled, ...restPopconfirmProps } = popconfirmProps

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setOpen(newOpen)
      return
    }

    if (disabled) {
      onConfirm()
    } else {
      setOpen(newOpen)
    }
  }

  return (
    <Popconfirm
      onConfirm={onConfirm}
      open={open}
      onOpenChange={handleOpenChange}
      styles={{
        root: {
          maxWidth: 400,
          width: 'auto',
        },
      }}
      {...restPopconfirmProps}
      trigger={'click'}
    >
      <GraviButton {...buttonProps} />
    </Popconfirm>
  )
}
